import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { UserStoreService } from '@auth/store/services/user-store.service';
import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';

const canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivateRoute(route, state);

const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivateRoute(route, state);

const canActivateRoute = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    const routeService = inject(RouteService);

    return inject(UserStoreService).getUser().pipe(
        take(1),
        switchMap(user => {
            if (user?.loginData != null) {

                routeService.navigate(RpcRoute.FindHome).catch(() => { });

                return of(false);
            }

            return of(true);
        })
    );
};

export { canActivate, canActivateChild };